module.exports = __webpack_public_path__ + "img/prev-icon.4411ade0.jpg";